import { css } from '@emotion/react';

import { useTranslation } from 'next-i18next';

import { useState } from 'react';

import { useModal } from '@hooks/useModal';
import { useModalStore } from '@stores/useModalStore';
import { Radio, Spacing } from 'chatie-design-system';

import { useWebView } from '@utils/webview';

import { ActionSheetOption } from '../common/ActionSheet';
import Modal, { ModalButton, ModalProps } from '../common/Modal';
import List from '../layout/List';

const ACTION_SHEET_MODAL_PREFIX = '__action-sheet';

const listCSS = css`
  > * + * {
    margin-top: ${Spacing.xsmall}px;
  }
`;

/**
 * 글로벌 액션시트 모달
 */
const ActionSheetModal = ({
  name,
  depth,
}: Pick<ModalProps, 'name' | 'depth'>) => {
  const { t } = useTranslation();

  const { app } = useWebView();

  const actionSheetName = useModalStore((state) =>
    state.current?.includes(ACTION_SHEET_MODAL_PREFIX)
      ? state.current
      : '__inactive'
  );

  const [isOpen, { close }, options] = useModal<ActionSheetOption[]>(
    actionSheetName,
    {
      routeChange: false,
    }
  );

  const [selected, setSelected] = useState(0);

  function handleSelect() {
    close({
      afterClose: () => {
        app.select(actionSheetName, selected);
      },
    });
  }

  return (
    <Modal
      open={isOpen}
      name="action-sheet-modal"
      onClose={close}
      title={t('옵션 선택')}
      depth={depth}
    >
      <List css={listCSS}>
        {options?.map((option, i) => (
          <li key={`action-sheet-option-${name}-${option.value}`}>
            <Radio
              id={`action-sheet-option-${option.value}`}
              name={`action-sheet-option-${name}`}
              value={option.value}
              checked={selected === i}
              onChange={() => setSelected(i)}
              label={option.isDanger ? `[주의] ${option.label}` : option.label}
            />
          </li>
        ))}
      </List>
      <ModalButton text={t('확인')} onClick={handleSelect} />
    </Modal>
  );
};

export default ActionSheetModal;
